export default class ReactInvalidComponentStateError extends Error {}
